export const AIRCRAFT_TYPES = Object.freeze({
  falcon: Object.freeze({
    id: 'falcon',
    name: 'Falcon F-9',
    role: 'Interceptor',
    description: 'Fast lock-on fighter with balanced armor.',
    maxSpeed: 142,
    cruiseSpeed: 108,
    acceleration: 1.08,
    turnRate: 1,
    climbRate: 1,
    health: 100,
    gunDamage: 8,
    missileDamage: 44,
    missiles: 4,
    scale: 0.76,
    wingSpan: 10.6,
    length: 13.4
  }),
  viper: Object.freeze({
    id: 'viper',
    name: 'Viper X-2',
    role: 'Air superiority',
    description: 'Agile dogfighter with the sharpest turning circle.',
    maxSpeed: 132,
    cruiseSpeed: 101,
    acceleration: 1.16,
    turnRate: 1.28,
    climbRate: 1.18,
    health: 82,
    gunDamage: 9,
    missileDamage: 38,
    missiles: 5,
    scale: 0.68,
    wingSpan: 9.5,
    length: 11.8
  }),
  titan: Object.freeze({
    id: 'titan',
    name: 'Titan A-40',
    role: 'Heavy strike',
    description: 'Armored attack aircraft with heavy weapons.',
    maxSpeed: 118,
    cruiseSpeed: 91,
    acceleration: 0.9,
    turnRate: 0.78,
    climbRate: 0.82,
    health: 145,
    gunDamage: 12,
    missileDamage: 58,
    missiles: 3,
    scale: 0.9,
    wingSpan: 13.4,
    length: 15.2
  })
});

export const AIRCRAFT_TYPE_LIST = Object.freeze(Object.values(AIRCRAFT_TYPES));

export function getAircraftType(id) {
  return AIRCRAFT_TYPES[id] ?? AIRCRAFT_TYPES.falcon;
}
